/**
 * One line of plain text from a markdown string: the first non-blank line
 * (code-fence markers skipped), with block markers (heading, quote, list,
 * task box) and inline syntax (emphasis, strike, code, links, images)
 * stripped. Grid cells stay one row tall; the full note lives in an editor
 * or a detail panel.
 */
export function markdownFirstLine(markdown: string): string {
  const line = markdown
    .split(/\r?\n/)
    .map((l) => l.trim())
    .find((l) => l !== '' && !/^(`{3,}|~{3,})/.test(l));
  if (!line) return '';
  return line
    .replace(/^#{1,6}\s+/, '') // heading
    .replace(/^(>\s*)+/, '') // blockquote
    .replace(/^([-*+]|\d+[.)])\s+/, '') // list item
    .replace(/^\[[ xX]\]\s+/, '') // task box
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1') // image → alt
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1') // link → text
    .replace(/`([^`]*)`/g, '$1') // inline code
    .replace(/\*\*(.+?)\*\*/g, '$1') // bold
    .replace(/(^|\W)__(.+?)__(?!\w)/g, '$1$2')
    .replace(/\*(.+?)\*/g, '$1') // italic
    .replace(/(^|\W)_(.+?)_(?!\w)/g, '$1$2') // (not inside snake_case words)
    .replace(/~~(.+?)~~/g, '$1') // strike
    .trim();
}
